<div class="container margintop" fxLayout="row" fxLayoutAlign="space-between start" fxLayout.xs="column" [fxLayoutGap]="item.gapBetweenImage">
  <div class="text-section" fxFlex="40"  fxFlex.xs="100">
    <div fxLayout="column"fxFlex="100">
      <div fxLayout="row" fxLayoutAlign="start start" *ngIf="item?.title?.length > 0">
        <calsoft-editor-text [data]="data" [text]="item.title" [ngStyle.gt-md]="{ 'font-size': item.customField34 }"
          [ngStyle.lt-md]="{ 'font-size': item.customField31 }">
        </calsoft-editor-text>
      </div>
      <div  fxLayoutAlign="start start" *ngIf="item?.customField7?.length > 0">
        <calsoft-editor-text style="text-align: left;" [data]="data" [text]="item.customField7"
          [ngStyle.gt-md]="{ 'font-size': item.customField34 }" [ngStyle.lt-md]="{ 'font-size': item.customField31 }">
        </calsoft-editor-text>
      </div>
      <div *ngIf="item?.customField6?.length > 0" style="width:100%;height: 250px;">
        <img   [src]="bannerServerPath+item.customField6" alt="img" style="width:100%;height: 250px;" />
      </div>
    </div>
  </div> 
  <div  fxFlex="50" fxFlex.xs="100" style="padding: 10px;">
    <div   fxLayout="row wrap" fxLayoutAlign="space-between center" >
      <div fxLayout="row" fxFlex="50" fxLayoutGap="10px"   *ngFor="let image of img" style="margin-bottom: 30px;cursor: pointer;">
        <img [ngStyle.lt-md]="{ 'height': item.heightMob, 'width': item.customField26 }"
            [style.height]="item.height"
            [style.width]="item.customField25" 
             (click)="image.navigation==0?goToCategories(image.catId):link(image.navigatedUrl)"
            [src]="bannerServerPath+image.img" alt="Samsung Next Logo" />
        <div>
          <div  [style.color]="item.customField5">
            <calsoft-editor-text [ngStyle.gt-md]="{'font-size': item.customField34 }" [ngStyle.lt-md]="{'font-size': item.customField31}" 
            [data]="data" [text]="image.customField20"></calsoft-editor-text>
          </div>
          <div [style.color]="item.customField5">
            <calsoft-editor-text  [ngStyle.gt-md]="{'font-size': item.customField34 }" [ngStyle.lt-md]="{'font-size': item.customField31}"
            [data]="data" [text]="image.customField21"></calsoft-editor-text>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
